<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="document-page">
      <h2 class="document-title">隐私政策</h2>
      <div class="document-date">用户隐私政策版本：2022-v.1.1</div>
      <p>开放原子开源基金会（下文简称“我们”或“基金会”）深知隐私对您的重要性，并会尊重您的隐私。请在向我们提交个人信息之前，阅读、了解本《隐私政策》（下文简称“本政策”）。本政策适用于显示本隐私政策或链接至本隐私政策的网站、内容及服务。
      </p>
      <p>本政策旨在协助您了解我们收集哪些信息、为何收集这些信息、以及如何使用、访问、修改、披露和删除您的个人信息，但本政策可能并不涉及所有可能的数据处理情境。有关收集内容或服务特定数据的信息可能由我们在补充政策中，或者在收集数据时提供的通知中发布。
      </p>
      <p>我们制定本政策的目的在于帮助您了解以下内容：</p>
      <ul>
        <li>1. 我们如何收集和使用您的个人信息</li>
        <li>2. 我们如何使用Cookie和同类技术</li>
        <li>3. 我们如何共享和披露您的个人信息</li>
        <li>4. 如何访问或修改您的个人信息</li>
        <li>5. 我们如何保护和留存您的个人信息</li>
        <li>6. 我们如何处理儿童的个人信息</li>
        <li>7. 您的个人信息如何在全球范围转移</li>
        <li>8. 本政策如何更新</li>
        <li>9. 如何联系我们</li>
      </ul>
      <h5>1. 我们如何收集和使用您的个人信息</h5>
      <p><b>1.1我们如何收集您的个人信息</b></p>
      <p>1.1.1个人信息是指是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。<b>您在使用我们内容或服务时，可能需要提供您的个人信息。</b>在某些情况下，您可以选择不向我们提供个人信息，但如果您选择不提供，我们可能无法为您提供相关内容或服务，也无法回应或解决您所遇到的问题。您的个人信息会在您使用基金会官方网站（下称“本网站”）、内容或服务，以及与我们互动时由您直接提交给我们。
      </p>
      <p>1.1.2我们可能会收集您的个人信息并用于以下目的：</p>
      <p>1.1.2.1 在以下场景我们将收集您的昵称、头像、电话和/或个人邮箱（下称“用户通用信息”）。</p>
      <ul>
        <li>（a） 当您创建基金会官方网站账号时；</li>
        <li>（b）当您联系我们获得支持时；</li>
        <li>（c）实现您的服务（包括但不限于提供兼容性测评服务并管理和处理兼容性测评结果等）请求；</li>
      </ul>
      <p>我们收集的数据取决于您与我们互动的方式，我们通过记录您如何与我们的网站、内容或服务交互（例如，通过Cookie等技术，或者从您设备上运行的软件接收使用数据）而收集您的“用户通用信息”。</p>
      <p>1.1.2.2 在以下场景我们除收集您的“用户通用信息”外，我们还会收集您的以下个人信息：</p>
      <ul>
        <li>(a) 如涉及基金会活动，还会收集您的姓名、性别、企业名称、职位、地址、电子邮箱、电话号码、登录信息（账号和密码）、照片、<b>身份证件信息</b>；</li>
        <li>(b) 如涉及支付的，为实现您的交易请求还会收集您的<b>银行名称、账户名称、银行账号</b>；如您通过第三方支付平台进行支付，我们会收集您的第三方支付平台的昵称、头像、用户ID；</li>
        <li>(c) 如您向我们提供信息或发送消息的（例如您输入的查询信息或您为了获得客服支持而提供的问题或信息），我们还收集您提供给我们的信息和您发给我们的消息内容；</li>
      </ul>
      <p>1.1.2.3
        目前我们不会主动从外部第三方获取您的个人信息，如未来为业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如我们对您个人信息的处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意。此外，我们将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。
      </p>
      <p>1.1.3
        我们还可能收集和使用非识别性数据。非识别性数据是指无法用于确定个人身份的信息。例如，我们会收集汇总的统计数据，例如网站访问量。我们收集此数据的目的在于了解用户如何使用本网站及其内容、服务。借此，我们可以改善自己的服务，更好地满足客户需求。我们可能会自行决定出于其他目的收集、使用、处理、转移或披露非识别性数据。
        我们会尽力隔离您的个人信息和非识别性数据，并单独使用这两种数据。如果个人信息掺杂了非识别性数据，依旧会被视作个人信息处理。</p>
      <p><b>1.2 我们如何使用您的个人信息</b></p>
      <p>我们将会严格按照相关法律法规的规定及与您的约定，将收集的信息按照本政策的规定用于以下用途：</p>
      <p>1.2.1为实现本隐私政策中“1.1我们如何收集您的个人信息”所述目的，我们承诺将收集的信息用于向您提供以下服务，包括但不限于：</p>
      <ul>
        <li>
          (a) 在您同意的情况下与您联系；<br>
          例如：向您发送有关您可能感兴趣的内容和服务的信息；邀请您参与我们活动（包括促销活动）、市场调查或满意度调查；或向您发送营销信息。如果您不想接收此类信息，则可以通过向mis@openatom.org邮箱发送邮件随时退订。
        </li>
        <li>(b) 向您发送重要通知（如操作系统或应用程序更新和安装的通知）；</li>
        <li>(c) 测评和管理供应商及业务合作伙伴，与供应商及业务合作伙伴沟通或开展业务；</li>
        <li>(d) 开展内部审计、数据分析和研究，改善我们的内容和服务；</li>
        <li>(e) 同步、共享和存储您上传或下载的数据以及执行上传和下载所需的数据；</li>
        <li>(f) 遵从和执行适用的法律要求、相关的行业标准或我们的政策。</li>
      </ul>
      <p>1.2.2 为订立或履行合同之必要。</p>
      <p>1.2.3 根据法律法规或监管要求向相关部门进行报告。</p>
      <p><b>您理解并知悉，匿名汇总统计数据不是可适用法律所定义的个人用户信息，我们将为多种目的，包括但不限于了解相关个人主体对我们产品及服务的购买意向，来保存和使用此类信息。</b></p>
      <p><b>如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们在使用您的个人信息前，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征得您的同意。</b>
      </p>
      <h5>2. 我们如何使用 Cookie 和同类技术</h5>
      <p><b>2.1 Cookie</b></p>
      <p>为确保网站正常运转，我们有时会在计算机或移动设备上存储名为Cookie的小数据文件。Cookie是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie
        的内容只能由创建它的服务器检索或读取。每个Cookie对您的网络浏览器或移动应用程序都是唯一的。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储用户偏好等数据。</p>
      <p>我们启用Cookie的目的与大多数网站或互联网服务提供商启用Cookie的目的一样，即改善用户体验。借助于Cookie，网站能够记住用户的单次访问（使用会话Cookie）或多次访问（使用永久Cookie）。借助于Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用Cookie，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站不会识别出您，而您会被再次注销。我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
      </p>
      <p><b>2.2 网站信标和像素标签</b></p>
      <p>除Cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的内容和服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
      </p>
      <p>您使用我们的网站意味着您同意按照如上所述使用Cookie，网站信标和像素标签。</p>
      <h5>3. 我们如何共享和披露您的个人信息</h5>
      <p><b>3.1共享</b></p>
      <p>除以下情况外，我们不会与任何其他公司、组织和个人共享您的个人信息：</p>
      <p>3.1.1事先向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类获得您的单独同意或授权。</p>
      <p>3.1.2根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
      <p>3.1.3当前我们的业务当前不涉及向相关关联主体共享您的个人信息。如因未来业务开展需要向我们的关联主体共享您的个人信息，我们会向您事前告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，如基于取得同意处理您的个人信息，我们会在面向关联主体共享您的个人信息之前获取您的单独同意。
      </p>
      <p>3.1.4与授权合作伙伴共享：我们当前不涉及委托授权合作伙伴为您提供某些服务。如因未来业务开展需要向授权合作伙伴共享您的个人信息，我们只会在必要、合理的范围内与授权合作伙伴共享您的某些个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协议或条款，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。在敏感个人信息的使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护您的个人信息。
      </p>
      <p><b>3.1.5为确保流畅的浏览体验，您可能会收到来自我们及其合作伙伴外部的第三方提供的内容或网络链接。我们对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容和服务。我们无法控制第三方的隐私和数据保护政策，此类第三方不受到本政策的约束。在向第三方提交个人信息之前，请参见这些第三方的隐私保护政策。</b>
      </p>
      <p><b>3.2公开披露</b></p>
      <p>我们仅会在以下情况下，公开披露您的个人信息</p>
      <p>3.2.1事先获得您的单独同意或授权。</p>
      <p>3.2.2在法律法规的要求、强制性的行政执法或司法要求的情况下，我们可能会公开披露您的个人信息。</p>
      <p>3.2.3法律法规规定的其他情形。</p>
      <h5>4. 如何访问或修改您的个人信息</h5>
      <p><b>4.1 查询您的个人信息</b></p>
      <p>您可以发送邮件至mis@openatom.org邮箱提出查询您的个人基本资料信息的请求，我们的工作人员会在收到您的请求后做出及时响应。</p>
      <p><b>4.2 更改您的个人信息</b></p>
      <p>当您发现收集、存储的个人信息有错误或者需要更新时，发送邮件至mis@openatom.org邮箱提出更改您个人信息的请求，我们的工作人员会在收到您的请求后做出及时响应。</p>
      <p><b>4.3 删除您的个人信息</b></p>
      <p>您可以发送邮件至mis@openatom.org邮箱提出删除您的个人信息的请求，我们的工作人员会在收到您的请求后做出及时响应。</p>
      <p>在以下情况发生时，您可以向我们提出删除个人信息的请求：</p>
      <ul>
        <li>(a) 我们没有征求您的明确同意，收集了您的个人信息，或您撤回我们处理您个人信息的同意的；</li>
        <li>(b) 我们处理您的个人信息违反了法律法规要求；</li>
        <li>(c) 我们处理、使用您的个人信息违反了与您的约定；</li>
        <li>(d) 您不再使用我们的产品或服务，或者注销账号，且超出个人信息保存期限的；</li>
        <li>(e) 我们不再为您提供产品或服务，且超出个人信息保存期限的。</li>
      </ul>
      <p><b>4.4 转移您的个人信息</b></p>
      <p>当您需要将您的个人信息转移至第三方个人信息处理者时，您可以通过发送邮件至mis@openatom.org邮箱提出您的请求，我们的工作人员会在收到您的请求后做出及时响应并协助您完成个人信息的转移。</p>
      <p><b>4.5 撤回您的授权同意</b></p>
      <p>您可以发送邮件至mis@openatom.org邮箱提出撤回您的授权同意的请求。当您撤回授权同意后，我们无法继续为您提供撤回授权同意所对应的服务。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </p>
      <p><b>4.6 获取您的个人信息副本</b></p>
      <p>您有权获取您的个人信息副本，您可发送邮件至mis@openatom.org邮箱，我们的工作人员会在收到您的请求后做出及时响应并进行相关操作。</p>
      <p>上述有关您个人信息的查询、更改、删除、撤回授权同意的请求，为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们将在合理时间内做出响应。</p>
      <p><b>4.7 无法响应您请求的情形</b></p>
      <p>在以下情形中，我们将无法响应您的请求：</p>
      <ul>
        <li>(a) 与个人信息控制者履行法律法规规定的义务相关的；</li>
        <li>(b) 与国家安全、国防安全直接相关的；</li>
        <li>(c) 与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>(d) 与刑事侦查、起诉、审判和执行判决等直接相关的；</li>
        <li>(e) 个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</li>
        <li>(f) 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
        <li>(g) 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</li>
        <li>(h) 涉及商业秘密的。</li>
      </ul>
      <p>除上述各项权利之外您对您的个人信息享有决定权、限制权、拒绝权、自动化决策相关权利，对前述各项权利的行使，您同样可以通过发送邮件至mis@openatom.org邮箱提出您的权利请求，我们的工作人员会在收到您的请求后做出及时响应并进行相关操作，确保您各项权利的有效行使。
      </p>
      <h5>5. 我们如何保护和留存您的个人信息</h5>
      <p>我们重视个人信息的安全。我们采用适当的物理、管理和技术保障措施来保护您的个人信息不被未经授权访问、披露、使用、修改、损坏或丢失。例如，我们会使用加密技术确保数据的机密性；我们会使用保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。我们会尽力保护您的个人信息，但是请注意任何安全措施都无法做到无懈可击。
      </p>
      <p>我们将会在达成本政策所述目的所需的期限内保留您的个人信息，除非按照法律要求或许可需要延长保留期或得到法律的允许。鉴于基于不同的场景和内容及服务的不同，数据的存储期可能会有所不同。我们用于确定存留期的标准包括：完成该业务目的（包括提供内容和服务，维护相应的交易及业务记录，管控并提升内容与服务性能与质量，保证系统、内容和服务的安全，应对可能的用户查询或投诉以及问题定位等）需要留存个人信息的时间；用户是否同意更长的留存期间；法律、合同等是否有保留数据的特殊要求等。只要您的账号是为您提供服务必须，我们都将保留您的注册信息。您也可以选择注销您的账号，在您注销账号后，我们会停止基于该账号提供内容和服务，并在无特殊法律要求的情况下，删除您相应的个人信息。
      </p>
      <h5>6. 我们如何处理儿童的个人信息 </h5>
      <p>本网站及其内容、服务主要面向成人。如果没有父母或监护人的同意，儿童（未满14周岁的未成年人）不得创建自己的用户账号。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或披露此数据。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
      </p>
      <h5>7. 您的个人信息如何在全球范围转移</h5>
      <p>我们是一家面向全球开源的基金会，这意味着，我们收集的您的个人信息可能会在您使用内容或服务所在国家/地区、在我们或其关联主体或服务提供商、业务合作伙伴设有机构的其他国家/地区进行处理，或者受到来自这些国家/地区的访问，这些国家/地区的数据保护法律和要求可能不同。在此类情况下，我们会采取措施确保我们收集的数据依据本政策及在适用的司法管辖区法律的要求进行处理。
      </p>
      <h5>8. 本政策如何更新</h5>
      <p>我们保留不时更新或修改本政策的权利。如果我们的隐私政策变更，我们会将最新版隐私政策在本网站上发布。如果我们对隐私政策做出了重大变更，我们还可能会通过不同渠道向您发送变更通知，例如，在本网站上发布通知或者向您发布单独的通知。
      </p>
      <h5>9. 如何联系我们</h5>
      <p>如果您有任何隐私疑问或投诉，您可以发送邮件至legal@openatom.org邮箱联系我们。一般情况下，我们将在15个工作日内回复。如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向基金会住所地有管辖权的法院提起诉讼来寻求解决方案。
      </p>

    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-page {
  width: 1200px;
  margin: 80px auto;
}

.document-page .document-title {
  color: #222;
  font-weight: 700;
  font-size: 42px;
  text-align: center;
}

.document-page .document-date {
  margin-top: 30px;
  color: #222;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}

.document-page > p {
  margin-top: 50px;
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > ul > li {
  color: #333;
  font-size: 18px;
  line-height: 28px;
}

.document-page > h5 {
  margin-top: 50px;
  color: #222;
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
}

.document-page b {
  text-decoration: underline;
}

@media (max-width: 1279.9px) {
  .document-page {
    width: auto;
    max-width: 1200px;
    padding: 0 24px;
  }
}

@media (max-width: 767.9px) {
  .document-page {
    margin: 40px auto;
    padding: 0 16px;
  }

  .document-page .document-title {
    font-size: 28px;
  }

  .document-page > p,
  .document-page > ul > li {
    font-size: 15px;
    line-height: 26px;
  }

  .document-page > h5 {
    font-size: 20px;
  }
}
</style>
